import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import ModalPortal from '../../../components/modal-portal';

import { Text, TextType } from 'ui-components/components/text';
import { Checkbox } from 'ui-components/components/checkbox';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';

import messages from './messages';
import styles from './styles.module.less';
import { FormattedMessage } from 'react-intl';

export const SaveConfirmationModal = ({ onSave, onClose }) => {
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const flipIsSaveEnabled = useCallback(() => setIsSaveEnabled((prev) => !prev), []);
  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.inventorySyncConfirmationTitle} />
        </ModalHeader>
        <ModalBody className={styles['modal-body']}>
          <Text textType={TextType.Paragraph} value={messages.inventorySyncConfirmationPrompt} />
          <ol className={styles['confirmation-list']}>
            <li>
              <Text textType={TextType.Paragraph} value={messages.inventorySyncOverwriteExisting} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.inventorySyncConfirmCorrectCounts} />
            </li>
          </ol>
          <Checkbox
            checked={isSaveEnabled}
            label={
              <Text
                className={styles.checkbox}
                onClick={flipIsSaveEnabled}
                textType={TextType.Label}
                value={messages.syncInventoryCheckboxLabel}
              />
            }
            onChange={flipIsSaveEnabled}
          />
        </ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton />
          <Button disabled={!isSaveEnabled} onClick={onSave} theme='primary'>
            <FormattedMessage {...messages.saveConfigurationButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

SaveConfirmationModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
